var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-dropdown",
        {
          attrs: {
            id: "dropdown_user_notif",
            variant: "outline-success",
            "no-caret": "",
          },
          scopedSlots: _vm._u([
            {
              key: "button-content",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "header-icon d-flex align-items-center justify-content-center ml-2 js-waves-off",
                      attrs: { title: _vm.user.name },
                    },
                    [
                      _c("span", { staticClass: "icon-stack fs-xxl" }, [
                        _c("i", {
                          staticClass: "base-2 icon-stack-3x color-primary-400",
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "base-10 text-white icon-stack-1x",
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass:
                            "ni md-profile color-primary-800 icon-stack-2x",
                        }),
                      ]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("b-dropdown-form", [
            _c("div", {}, [
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-header bg-trans-gradient d-flex flex-row py-4 rounded-top",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-row align-items-center mt-1 mb-1 color-white",
                    },
                    [
                      _c("div", { staticClass: "info-card-text" }, [
                        _c(
                          "div",
                          {
                            staticClass: "fs-lg text-truncate text-truncate-lg",
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t" +
                                _vm._s(_vm.user.name) +
                                "\n\t\t\t\t\t\t\t\t"
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "text-truncate text-truncate-md opacity-80",
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.user.email) +
                                "\n                                "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-divider m-0" }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  attrs: { href: "/user/profile" },
                },
                [
                  _c(
                    "span",
                    { attrs: { "data-i18n": "drpdwn.reset_layout" } },
                    [
                      _vm._v(
                        "\n                          \t" +
                          _vm._s(_vm.__t("USER_PROFILE")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-divider m-0" }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  attrs: { href: "#", "data-action": "app-fullscreen" },
                },
                [
                  _c("span", { attrs: { "data-i18n": "drpdwn.fullscreen" } }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(_vm.__t("FULL_SCREEN")) +
                        "\n                        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "float-right text-muted fw-n" }, [
                    _vm._v("F11"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-divider m-0" }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item fw-500 pt-3 pb-3",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.logout.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { attrs: { "data-i18n": "drpdwn.page-logout" } }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(_vm.__t("USER_EXIT")) +
                        "\n\t\t\t\t\t\t"
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }